export function calculateGcd(numbers) {
  if (!Array.isArray(numbers) || numbers.length === 0) {
    return null
  }

  const validNumbers = numbers
    .map((num) => {
      if (typeof num === 'string') {
        const parsed = parseFloat(num)
        return isNaN(parsed) ? null : parsed
      }
      return num
    })
    .filter(
      (num) =>
        typeof num === 'number' &&
        !isNaN(num) &&
        num !== undefined &&
        isFinite(num)
    )

  if (validNumbers.length === 0) {
    return null
  }

  if (validNumbers.length === 1) {
    return Math.abs(validNumbers[0])
  }

  return validNumbers.reduce((acc, num) => gcd(acc, num))
}

function gcd(a, b) {
  if (b === 0) {
    return Math.abs(a)
  }

  a = Math.abs(a)
  b = Math.abs(b)

  while (b !== 0) {
    let temp = b
    b = a % b
    a = temp
  }

  return a
}
